export default __webpack_public_path__ + "static/media/suzanaruth.1df2b921.jpg";